// A UUID never contains "~", so the key splits back unambiguously.
var ISSUE_SEPARATOR = "~";
export var unitKey = function (titleId, issueId) {
    return issueId ? "".concat(titleId).concat(ISSUE_SEPARATOR).concat(issueId) : titleId;
};
export var parseUnitKey = function (key) {
    var separatorAt = key.indexOf(ISSUE_SEPARATOR);
    if (separatorAt < 0) {
        return { titleId: key, issueId: null };
    }
    return {
        titleId: key.slice(0, separatorAt),
        issueId: key.slice(separatorAt + 1) || null,
    };
};
export var isIssueUnitKey = function (key) {
    return parseUnitKey(key).issueId !== null;
};
var splitKeys = function (keys) {
    var titleIds = [];
    var issueIds = [];
    Array.from(keys).forEach(function (key) {
        var _a = parseUnitKey(key), titleId = _a.titleId, issueId = _a.issueId;
        if (issueId) {
            issueIds.push(issueId);
        }
        else {
            titleIds.push(titleId);
        }
    });
    return { titleIds: titleIds, issueIds: issueIds };
};
var nonEmpty = function (ids) { return (ids.length > 0 ? ids : undefined); };
export var unitIncludeSelection = function (keys) {
    var _a = splitKeys(keys), titleIds = _a.titleIds, issueIds = _a.issueIds;
    return {
        includeIds: nonEmpty(titleIds),
        includeIssueIds: nonEmpty(issueIds),
    };
};
export var unitExcludeSelection = function (keys) {
    var _a = splitKeys(keys), titleIds = _a.titleIds, issueIds = _a.issueIds;
    return {
        excludeIds: nonEmpty(titleIds),
        excludeIssueIds: nonEmpty(issueIds),
    };
};
